import React from "react";
import { Tooltip } from "@blueprintjs/core";
import { PopoverPosition } from "@blueprintjs/core";
import classNames from "classnames";
import ErrorIcon from "icons/info_triangle.svg";
import * as styles from "./styles.module.scss";
const BiasedIcon = ({ errorsPlotLayout, firstError, sourceView, totalRunsCount, errorCount, setErrorsPlotLayout, onOpen, }) => (React.createElement(Tooltip, { minimal: true, content: React.createElement(React.Fragment, null,
        React.createElement("p", { className: styles["tooltip-title"] }, "Data is biased"),
        errorCount !== undefined && (React.createElement("p", null,
            errorCount,
            " out of ",
            totalRunsCount,
            " runs failed")),
        React.createElement("p", null, firstError)), portalClassName: styles.tooltipPortal, popoverClassName: styles.tooltip, position: PopoverPosition.BOTTOM, rootBoundary: "viewport", boundary: "clippingParents", openOnTargetFocus: false },
    React.createElement(ErrorIcon, { className: classNames(styles["error-icon"], { [styles.pointer]: sourceView }), onClick: () => {
            if (!sourceView) {
                return;
            }
            setErrorsPlotLayout((prevLayout) => ({
                ...errorsPlotLayout,
                xaxis: { ...prevLayout?.xaxis, autorange: true },
                yaxis: { ...prevLayout?.yaxis, fixedrange: false, autorange: true },
                yaxis2: { ...prevLayout?.yaxis2, fixedrange: false, autorange: true },
            }));
            onOpen(true);
        } })));
export default BiasedIcon;
